<div>
    <div style="display: flex; align-items: center;margin-top: -33px;">
        <div style="margin-left: auto;">
            <a class="fa fa-question-circle help-icon ml-1" pTooltip="Help" tooltipPosition="left"
                (click)="PagehelpmodalService.openhelpmodal(ref,dialogService,'Help',22)" aria-hidden="true"></a>
        </div>
    </div>
    <div class="date-wrapper center-container-date">
        <div class="date-box">
            <label for="fromdate" class="label-spacing bold-red-text">From Date</label>
            <p-calendar [showIcon]="true" pTooltip="From Date" placeholder="Choose Date" dateFormat="dd-M-yy"
                inputId="fromdate" [selectOtherMonths]="true" [(ngModel)]="fromDate" styleClass="pcalendar-readonly"
                [readonlyInput]="true" (onSelect)="validateDates()" [pTooltip]="getdatetooltip()"
                [clearButtonStyleClass]="'hideClearButton'" [showButtonBar]="true">
            </p-calendar>
            <div class="error-space">
                <span *ngIf="errorFromDate" class="date-error">From Date is required</span>
            </div>
        </div>

        <div class="date-box">
            <label for="todate" class="label-spacing bold-red-text">To Date</label>
            <p-calendar [showIcon]="true" pTooltip="To Date" placeholder="Choose Date" [(ngModel)]="toDate"
                dateFormat="dd-M-yy" inputId="todate" [readonlyInput]="true" (onSelect)="validateDates()"
                [pTooltip]="getdatetooltip()" [clearButtonStyleClass]="'hideClearButton'" [selectOtherMonths]="true"
                styleClass="pcalendar-readonly" [showButtonBar]="true">
            </p-calendar>
            <div class="error-space">
                <span *ngIf="errorDIsplay" class="date-error">To date should be greater than from date</span>
                <span *ngIf="errorToDate" class="date-error">To Date is required</span>
            </div>
        </div>

        <div class="btn-box">
            <p-button styleClass="refreshbtn reset-btn" severity="success" pTooltip="Reset" (click)="refreshFilters()">
                <i class="fa fa-refresh" aria-hidden="true"></i>
            </p-button>
            <div class="error-space"></div>
        </div>
    </div>
</div>
<div>
    <div class="dashboard-report-card">
        <div id="client-usage-report" class="client-usage-report">
            <div class="report-header">
                <h4 class="report-title-text">Client Usage Report</h4>

                <i class="fa fa-info-circle report-info-icon" pTooltip="Information" tooltipPosition="left"
                    (click)="getScoringReportFormula('CLIENT')">
                </i>
            </div>
            <div class="table-wrapper">
                <table id="myTable" class="table table-striped table-bordered usage-table">
                    <thead class="theadcl">
                        <tr>
                            <th class="sticky-col">File (MB)</th>

                            <!-- Compliance -->
                            <ng-container *ngIf="compprod === 'Compliance'">
                                <th class="text-center" pTooltip="Non Compliance">NC</th>
                                <th class="text-center" *ngIf="ancflag === 'Y'" pTooltip="Pending Approval">ANC</th>
                                <th class="text-center" pTooltip="Late Closure">LC</th>
                                <th class="text-center" pTooltip="On Time">OT</th>
                                <th class="text-center" pTooltip="Not Applicable">NA</th>
                                <th class="text-center" pTooltip="Pending Approval">PA</th>
                                <th class="text-center" pTooltip="Due">Due</th>
                                <th class="text-center" pTooltip="Total">Total</th>
                                <th class="text-center" pTooltip="Action %">Action %</th>
                                <th class="text-center" pTooltip="Internal Compliance">IC</th>
                            </ng-container>
                            <th *ngIf="taskprod === 'Task'" class="text-center" pTooltip="Tasks">Tasks</th>
                            <th *ngIf="contprod === 'Contract'" class="text-center" pTooltip="Contract">Contract</th>
                            <th *ngIf="regprod === 'Registration'" class="text-center" pTooltip="Registration">
                                Registration</th>
                            <th *ngIf="insprod === 'Insurance'" class="text-center" pTooltip="Insurance">Insurance</th>
                            <th *ngIf="assesprod === 'Assessment'" class="text-center" pTooltip="Assessment">Assessment
                            </th>
                            <th *ngIf="ifcprod === 'IFC'" class="text-center" pTooltip="Internal Financial Controls">IFC
                            </th>
                            <ng-container *ngIf="litprod === 'Litigation'">
                                <th class="text-center" pTooltip="Litigation">Litigation</th>
                                <th class="text-center" pTooltip="Notice">Notice</th>
                            </ng-container>
                            <ng-container *ngIf="audprod === 'Audit'">
                                <th class="text-center" pTooltip="Audit">Audit</th>
                                <th class="text-center" pTooltip="Observation">Observation</th>
                            </ng-container>
                            <!-- <ng-container *ngIf="helprod === 'Helpdesk'">
                                <th class="text-center" pTooltip="HD Customer">Help Desk<br>
                                    <small class="count-text">Customer(Count)</small>
                                </th>
                                <th class="text-center" pTooltip="HD ESLC">Help Desk <br>
                                    <small class="count-text">Complinity (Count)</small>
                                </th>
                                <th class="text-center" pTooltip="Help Desk Attachment">Help Desk <br>
                                    <small class="count-text">Attachment(Count)</small>
                                </th>
                            </ng-container> -->
                            <th class="text-center" pTooltip="Attach Main">Attachment<br><small
                                    class="count-text">(Count)</small>
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <td class="text-center sticky-col" tooltipPosition="top" pTooltip="{{fileSizeMB}}">{{
                                fileSizeMB }}</td>
                            <ng-container *ngIf="compprod === 'Compliance'">
                                <td class="text-center" tooltipPosition="top" pTooltip="{{nccred}}">{{ nccred }}
                                </td>
                                <td class="text-center" *ngIf="ancflag === 'Y'" tooltipPosition="top"
                                    pTooltip="{{ncclightred}}">{{ ncclightred }}</td>
                                <td class="text-center" tooltipPosition="top" pTooltip="{{corange}}">{{ corange
                                    }}</td>
                                <td class="text-center" tooltipPosition="top" pTooltip="{{cgreen}}">{{ cgreen }}
                                </td>
                                <td class="text-center" tooltipPosition="top" pTooltip="{{cgrey}}">{{ cgrey }}
                                </td>
                                <td class="text-center" tooltipPosition="top" pTooltip="{{cpink}}">{{ cpink }}
                                </td>
                                <td class="text-center" tooltipPosition="top" pTooltip="{{nccyellow}}">{{ nccyellow
                                    }}</td>
                                <td class="text-center" tooltipPosition="top" pTooltip="{{total}}">{{ total }}
                                </td>
                                <td class="text-center" tooltipPosition="top" pTooltip="{{actionPercentage}}">{{
                                    actionPercentage }}%</td>
                                <td class="text-center" tooltipPosition="top" pTooltip="{{iscompint}}">{{ iscompint
                                    }}</td>
                            </ng-container>
                            <td *ngIf="taskprod === 'Task'" class="text-center" tooltipPosition="top"
                                pTooltip="{{counttask}}">{{ counttask }}</td>
                            <td *ngIf="contprod === 'Contract'" class="text-center" tooltipPosition="top"
                                pTooltip="{{countcontract}}">{{ countcontract }}</td>
                            <td *ngIf="regprod === 'Registration'" class="text-center" tooltipPosition="top"
                                pTooltip="{{countreg}}">{{ countreg }}</td>
                            <td *ngIf="insprod === 'Insurance'" class="text-center" tooltipPosition="top"
                                pTooltip="{{countinsrnce}}">{{ countinsrnce }}</td>
                            <td *ngIf="assesprod === 'Assessment'" class="text-center" tooltipPosition="top"
                                pTooltip="{{countasses}}">{{ countasses }}</td>
                            <td *ngIf="ifcprod === 'IFC'" class="text-center" tooltipPosition="top"
                                pTooltip="{{countifc}}">{{ countifc }}</td>
                            <ng-container *ngIf="litprod === 'Litigation'">
                                <td class="text-center" tooltipPosition="top" pTooltip="{{countltgsn}}">{{
                                    countltgsn }}</td>
                                <td class="text-center" tooltipPosition="top" pTooltip="{{countltgsnnotice}}">{{
                                    countltgsnnotice }}</td>
                            </ng-container>
                            <ng-container *ngIf="audprod === 'Audit'">
                                <td class="text-center" tooltipPosition="top" pTooltip="{{countia}}">{{ countia
                                    }}</td>
                                <td class="text-center" tooltipPosition="top" pTooltip="{{countiafind}}">{{
                                    countiafind }}</td>
                            </ng-container>
                            <!-- <ng-container *ngIf="helprod === 'Helpdesk'">
                                <td class="text-center" tooltipPosition="top" pTooltip="{{counthdcustmr}}">{{
                                    counthdcustmr }}</td>
                                <td class="text-center" tooltipPosition="top" pTooltip="{{counthdeslc}}">{{
                                    counthdeslc }}</td>
                                <td class="text-center" tooltipPosition="top" pTooltip="{{counthdattach}}">{{
                                    counthdattach }}</td>
                            </ng-container> -->
                            <td class="text-center" tooltipPosition="top" pTooltip="{{counthdmnattach}}">{{
                                counthdmnattach }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="report-divider"></div>
        <div *ngIf="compprod === 'Compliance'" id="compliance-scoring-report m-1" class="client-usage-report">
            <div class="report-header">
                <h4 class="report-title-text">Compliance Scoring Report</h4>

                <i class="fa fa-info-circle report-info-icon" pTooltip="Information" tooltipPosition="left"
                    (click)="getScoringReportFormula('SCORING')">
                </i>
            </div>

            <div class="table-wrapper">
                <table class="table table-striped table-bordered usage-table scoring-table">
                    <colgroup>
                        <col style="width:14%">
                        <col style="width:14%">
                        <col style="width:14%">
                        <col style="width:15%">
                        <col style="width:15%">
                        <col style="width:14%">
                        <col style="width:14%">
                    </colgroup>

                    <thead class="theadclrisk">
                        <tr>
                            <th class="text-center sticky-col" pTooltip="Total Compliances">Total Compliances</th>
                            <th class="text-center" pTooltip="Total Non-Compliances">Total Non-Compliances</th>
                            <th class="text-center" pTooltip="Imprisonment Exposure">
                                Imprisonment Exposure<br>
                                <small>[Actual Imprisonment]</small>
                            </th>
                            <th class="text-center"
                                pTooltip="License Cancellation Exposure[Actual License Cancellation]">
                                License Cancellation Exposure<br>
                                <small>[Actual License Cancellation]</small>
                            </th>
                            <th class="text-center" pTooltip="Total Penalty Exposure (Rs)">Total Penalty Exposure (Rs)
                            </th>
                            <th class="text-center" pTooltip="Total NC Exposure (Rs)">Total NC Exposure (Rs)</th>
                            <th class="text-center" pTooltip="Total Penalty Paid (Rs)">Total Penalty Paid (Rs)</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <td class="text-center sticky-col" tooltipPosition="top" pTooltip="{{totalCompliance}}">{{
                                totalCompliance }}</td>
                            <td class="text-center" tooltipPosition="top" pTooltip="{{totalNonCompliance}}">{{
                                totalNonCompliance }}</td>

                            <td class="text-center" tooltipPosition="top" pTooltip="{{imprisonmentExposure}}">
                                {{ imprisonmentExposure }}% [{{ imprisonmentActual }}]
                            </td>

                            <td class="text-center" tooltipPosition="top" pTooltip="{{licenseExposure}}">
                                {{ licenseExposure }}% [{{ licenseActual }}]
                            </td>

                            <td class="text-center" tooltipPosition="top" pTooltip="{{totalPenaltyExposure}}">{{
                                totalPenaltyExposure }}</td>
                            <td class="text-center" tooltipPosition="top" pTooltip="{{totalNcExposure}}">{{
                                totalNcExposure }}</td>
                            <td class="text-center" tooltipPosition="top" pTooltip="{{totalPenaltyPaid}}">{{
                                totalPenaltyPaid }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>


    <div class="grid" style="margin-top: 0.5rem;">
        <div class="col-12 md:col-6 lg:col-6" *ngIf="compprod === 'Compliance'">
            <div class="text-center p-1 border-round-sm font-bold">
                <div class="card chart" id="compliancePie"></div>
            </div>
        </div>

        <div class="col-12 md:col-6 lg:col-6" *ngIf="contprod === 'Contract'">
            <div class="text-center p-1 border-round-sm font-bold">
                <div class="card chart" id="contractPie"></div>
            </div>
        </div>

    </div>

    <div class="grid" style="margin-top: 0.0rem;">
        <div class="col-12 md:col-6 lg:col-6" *ngIf="regprod === 'Registration'">
            <div class="text-center p-1 border-round-sm font-bold">
                <div class="card pie-chart-container" id="registrationPie"
                    style="height: 400px; cursor: pointer; margin: 0;"></div>
            </div>
        </div>
        <div class="col-12 md:col-6 lg:col-6" *ngIf="insprod === 'Insurance'">
            <div class="text-center p-1 border-round-sm font-bold">
                <div class="card pie-chart-container" id="insurancepie"
                    style="height: 400px; cursor: pointer; margin: 0;"></div>
            </div>
        </div>
    </div>

    <div class="grid" style="margin-top: 0.0rem;">
        <div class="col-12 md:col-6 lg:col-6" *ngIf="assesprod === 'Assessment'">
            <div class="text-center p-1 border-round-sm font-bold">
                <div class="card pie-chart-container" id="assessmentpie"
                    style="height: 400px; cursor: pointer; margin: 0;"></div>
            </div>
        </div>
        <div class="col-12 md:col-6 lg:col-6" *ngIf="ifcprod === 'IFC'">
            <div class="text-center p-1 border-round-sm font-bold">
                <div class="card pie-chart-container" id="ifcpie" style="height: 400px; cursor: pointer; margin: 0;">
                </div>
            </div>
        </div>
    </div>

    <div class="grid" style="margin-top: 0.0rem;">
        <div class="col-12 md:col-6 lg:col-6" *ngIf="litprod === 'Litigation'">
            <div class="text-center p-1 border-round-sm font-bold">
                <div class="card pie-chart-container" id="litigationpie"
                    style="height: 400px; cursor: pointer; margin: 0;"></div>
            </div>
        </div>
        <div class="col-12 md:col-6 lg:col-6" *ngIf="litprod === 'Litigation'">
            <div class="text-center p-1 border-round-sm font-bold">
                <div class="card pie-chart-container" id="noticepi" style="height: 400px; cursor: pointer; margin: 0;">
                </div>
            </div>
        </div>
    </div>

    <div class="grid" style="margin-top: 0.0rem;">
        <div class="col-12 md:col-6 lg:col-6" *ngIf="audprod === 'Audit'">
            <div class="text-center p-1 border-round-sm font-bold">
                <div class="card pie-chart-container" id="auditpie" style="height: 400px; cursor: pointer; margin: 0;">
                </div>
            </div>
        </div>
        <div class="col-12 md:col-6 lg:col-6" *ngIf="audprod === 'Audit'">
            <div class="text-center p-1 border-round-sm font-bold">
                <div class="card pie-chart-container" id="obsstatuspie"
                    style="height: 400px; cursor: pointer; margin: 0;">
                </div>
            </div>
        </div>
    </div>

</div>